import styles from "./MainVideoModal.module.css";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { useDispatch } from "react-redux";
import { setCurrentModule } from "../../../store/reducers/progressionReducer";
import { useRef, useEffect, useState } from "react";
import LargePanel from "../../SvgComponents/LargePanel";
import ButtonClose from "../../Componenents/ButtonClose/ButtonClose";

export default function MainVideoModal({ src, titleSection, title, desc, author, stylesAdd }) {
  const dispatch = useDispatch();
  const containerRef = useRef();
  const videoRef = useRef();
  const [isPortrait, setIsPortrait] = useState(false);

  const { contextSafe } = useGSAP();

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.addEventListener('loadedmetadata', () => {
        const ratio = videoRef.current.videoWidth / videoRef.current.videoHeight;
        setIsPortrait(ratio < 1);
      });
    }
  }, [src]);

  useGSAP(() => {
    if (containerRef.current) {
      const isMobile = window.innerWidth <= 768;

      gsap
        .timeline()
        .to(".modalFrame", {
          opacity: 1,
          pointerEvents: "auto",
          duration: 1,
          ease: "power2.out",
        })
        .fromTo(
          containerRef.current,
          {
            opacity: 0,
            scale: 0.65,
          },
          { opacity: 1, scale: 1, ease: "power2.out", duration: 0.5 },
          ">-.75",
        )
        .fromTo(
          `.${styles.videoContainer}`,
          {
            scale: 0.75,
          },
          {
            scale: 1,
            ease: "power4.out",
            duration: 0.75,
          },
          "<",
        )
        .fromTo(
          `.${styles.video}`,
          {
            scale: 1.25,
          },
          {
            scale: 1,
            ease: "power2.out",
            duration: 0.75,
          },
          "<",
        )
        .fromTo(
          containerRef.current,
          {
            padding: "-2rem",
          },
          { padding: isMobile ? "1rem" : "2rem", ease: "back.out(1.2)", duration: 0.65 },
          ">-.55",
        )
        .fromTo(
          `.${styles.close}`,
          {
            opacity: 0,
          },
          { opacity: 1, ease: "power2.out", duration: 1 },
          ">-.3",
        );
    }
  });

  const closeEvent = contextSafe(() => {
    gsap
      .timeline({
        onComplete: () => {
          dispatch(setCurrentModule("none"));
        },
      })
      .to(".modalFrame", {
        opacity: 0,
        pointerEvents: "none",
        duration: 1,
        ease: "power2.out",
      })
      .to(
        `.${styles.videoContainer}`,
        {
          scale: 0.85,
          ease: "power4.out",
          duration: 0.75,
        },
        "<",
      )
      .to(
        containerRef.current,
        {
          padding: "-2rem",
          scale: 0.95,
          opacity: 0,
          ease: "back.out(1.2)",
          duration: 0.5,
        },
        "<",
      );
  });

  return (
    <div className={`${styles.MainVideoModal} ${stylesAdd}`} ref={containerRef}>
      <ButtonClose stylesBis={styles} onClick={closeEvent}></ButtonClose>

      <h2 className={styles.titleSection}>{titleSection}</h2>
      <div className={`${styles.videoContainer} ${isPortrait ? styles.portrait : styles.landscape}`}>
        <video
          className={styles.video}
          controls
          key={src}
          ref={videoRef}
          onCanPlay={(e) => {
            // Tenter de réactiver le son sur Firefox
            try {
              e.target.muted = false;
              e.target.volume = 1.0;
            } catch (err) {
              console.log("Erreur lors de la réactivation du son :", err);
            }
          }}
        >
          <source src={src} type="video/mp4" />
          Votre navigateur ne prend pas en charge la lecture de vidéos MP4.
        </video>
      </div>
      <div className={styles.videoInfos}>
        <h4 className={styles.author}>{author}</h4>
        <div className={styles.desc}>
          <h3 className={styles.titleVideo}>{title}</h3>
          <p className={styles.descContent}>{desc}</p>
        </div>
      </div>
    </div>
  );
}
